import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_40, COLOR_GRAY_70, COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  titleQuestions: {
    fontSize: 30,
    color: COLOR_GRAY_70,
    fontWeight: 'bold',
    marginBottom: 32,
  },
  question: {
    backgroundColor: 'transparent !important',
    boxShadow: 'none !important',
    borderBottom: `1px solid ${COLOR_GRAY_40} !important`,
    padding: '4px 0',
    borderRadius: '0px !important',
    '& .MuiAccordionSummary-expandIcon': {
      padding: 0,
    },
    '&:before': {
      display: 'none',
    },
    '& div, p': {
      margin: '0 !important',
    },
  },
  questionTitle: {
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: 700,
    color: COLOR_PURPLE,
    margin: 0,
  },
  accordionSummaryContent: {
    '& div': {
      margin: 0,
    },
  },
  accordionDetailsParagrath: {
    margin: 0,
    fontSize: '0.875rem',
    fontStyle: 'normal',
    fontWeight: 400,
    color: COLOR_GRAY_70,
  },
  expandMoreIcon: {
    color: COLOR_GRAY_40,
  },
  subtitle: {
    color: COLOR_GRAY_70,
    fontFamily: 'Lato',
    fontSize: 20,
    textAlign: 'center',
    margin: '0 auto',
    marginTop: -theme.spacing(2),
    marginBottom: theme.spacing(6.75),
  },
}));
